import axios from 'axios';
import config from '../config';

const tourService = {
    // Tour duration'larını getir
    getTourDurations: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.get(`${config.API_BASE_URL}v1/tour/durations`, {
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            // API response yapısına göre data array'ini return et
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching tour durations:', error);
            throw error;
        }
    },

    // Tour tiplerini getir
    getTourTypes: async () => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.get(`${config.API_BASE_URL}v1/tour/tour-types`, {
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            // API response yapısına göre data array'ini return et
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching tour types:', error);
            throw error;
        }
    },

    // Tour autocomplete
    getTourAutoComplete: async (searchText) => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.get(`${config.API_BASE_URL}v1/tour/search`, {
                params: {
                    search: searchText
                },
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            // API response yapısına göre data array'ini return et
            return response.data.data || [];
        } catch (error) {
            console.error('Error fetching tour autocomplete:', error);
            throw error;
        }
    },

    // Tour arama
    searchTours: async (requestData) => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.post(`${config.API_BASE_URL}v1/tour`, requestData, {
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error searching tours:', error);
            throw error;
        }
    },

    // URL parametrelerinden tour arama parametrelerini hazırla ve API'ye gönder
    searchToursFromUrlParams: async (urlParams) => {
        try {
            // URL parametrelerini API request formatına dönüştür
            const requestData = {
                page: parseInt(urlParams.get('page')) || 1,
                perPage: parseInt(urlParams.get('perPage')) || 10,
                search: urlParams.get('search') || '',
                period: urlParams.get('period') ? urlParams.get('period').split(',') : [],
                duration: urlParams.get('duration') || 'single',
                tourTypeIds: urlParams.get('tourTypeIds') ? urlParams.get('tourTypeIds').split(',').map(id => parseInt(id)) : [],
                coordinates: {
                    latitude: urlParams.get('lat') ? parseFloat(urlParams.get('lat')) : null,
                    longitude: urlParams.get('lng') ? parseFloat(urlParams.get('lng')) : null
                }
            };

            console.log('Tour search request from URL params:', requestData);
            
            // API çağrısı yap
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.post(`${config.API_BASE_URL}v1/tour`, requestData, {
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            // Tam response'u döndür (pagination bilgisi ile birlikte)
            return response.data;
        } catch (error) {
            console.error('Error searching tours from URL params:', error);
            throw error;
        }
    },

    // Tour detay getir
    getTourDetail: async (tourId) => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.get(`${config.API_BASE_URL}v1/tour/${tourId}/detail`, {
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error fetching tour detail:', error);
            throw error;
        }
    },

    // Tour price calculator
    calculateTourPrice: async (tourId, requestData) => {
        try {
            const userData = JSON.parse(localStorage.getItem('user_data'));
            
            const response = await axios.post(`${config.API_BASE_URL}v1/tour/${tourId}/price-calculator`, requestData, {
                headers: {
                    'Authorization': `Bearer ${userData?.token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error calculating tour price:', error);
            throw error;
        }
    }
};

export default tourService; 